export default function Logo({ className = '' }: { className?: string }) {
  return (
    <div className={`flex flex-col items-center leading-none ${className}`}>
      <div className="flex items-center gap-2 font-display tracking-widest">
        <span className="text-orange text-4xl">[</span>
        <span className="text-blanc text-3xl tracking-[0.3em]">PIVOT</span>
        <span className="text-orange text-4xl">]</span>
      </div>
      <div className="text-acier text-sm tracking-[0.5em] mt-1">MÉDIA</div>
    </div>
  )
}
